import { AppLinkKey } from '@app/config/appLink'
import { guideContentTypes } from '../config/guide.config'

export const guideContentTypeLinkMap: Partial<
  Record<(typeof guideContentTypes)[number], AppLinkKey>
> = {
  fundamentals: 'guideFundamentals',
  methods: 'guideMethods',
  insights: 'guideInsights',
  tutorials: 'guideTutorials',
  demos: 'guideDemos',
  glossary: 'guideGlossary',
}
